import { Button } from 'primereact/button'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Loading from '../../../components/Loading'
import {
  checkIfTeamNameIsAddedRequest,
  fetchGameLocalesRequest,
} from '../../../redux/actions/gameActions'
import { getGameSelector } from '../../../redux/selectors/gameSelectors'
import { GameState } from '../../../redux/types/game'
import clickSoundEffect from '../../../assets/audio/click2.wav'
import Language from './Language'
import useSound from 'use-sound'
import { ArrowRight } from 'iconsax-react'
import { useTranslation } from 'react-i18next'
import Consent from './Consent'
import ChooseLanguageIllustration from './ChooseLanguageIllistration'
import * as Sentry from '@sentry/react'
import jwt_decode from 'jwt-decode'

const ChooseLanguage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const {
    loading: gameLoading,
    data: {
      isTeamNameAdded,
      volumeGlobal,
      branding,
      selectedLanguage,
      gameLocales,
    },
  }: GameState = useSelector(getGameSelector)
  const token = localStorage.getItem('tokenCityHunt') ?? ''
  const { GameId }: any = jwt_decode(token)

  const [clickSound] = useSound(clickSoundEffect, {
    volume: volumeGlobal,
  })

  useEffect(() => {
    if (!gameLocales) {
      dispatch(fetchGameLocalesRequest(GameId))
    }
    dispatch(checkIfTeamNameIsAddedRequest())
  }, [])

  useEffect(() => {
    if (isTeamNameAdded) {
      Sentry.captureMessage('Uslo ChooseLanguage isTeamNameAdded', 'warning')
      Sentry.setContext('Variables', {
        token: localStorage.getItem('tokenCityHunt'),
        isTeamNameAdded,
      })
      navigate('/welcome')
    }

    Sentry.captureMessage('Uslo ChooseLanguage useEffect[]', 'warning')
    Sentry.setContext('Variables', {
      token: localStorage.getItem('tokenCityHunt'),
      isTeamNameAdded,
    })
  }, [isTeamNameAdded])

  if (gameLoading.isLoadingTeamNameExists || isTeamNameAdded) {
    return <Loading />
  }

  return (
    <>
      {selectedLanguage && <Consent />}
      <div
        style={{ width: '100%', height: '100vh' }}
        className="flex flex-column align-items-center"
      >
        <div
          style={{
            width: '100%',
            height: '20vh',
            background: branding?.steps.backgroundColor,
          }}
          className="flex justify-content-center align-items-center"
        >
          <h4
            className="zoominleft animation-duration-1000"
            style={{ color: branding?.steps.textColor, marginTop: '-15%' }}
          >
            {t('Step')} 1/3
          </h4>
        </div>
        <div
          style={{
            // width: '90%',
            // borderTopRightRadius: '50%',
            // borderTopLeftRadius: '50%',
            borderRadius: '27px',
            marginTop: '-20%',
            background: ' #fff',
            height: '90vh',
            // padding: '4vw',
            width: '100%',
          }}
          className="flex justify-content-center"
        >
          {/* <div className="w-full flex align-items-center justify-content-center"> */}
          <div
            style={{
              width: '90%',
              margin: 'auto',
              // minHeight: '70vh',
            }}
            className="flex flex-column align-items-stretch text-center justify-content-evenly"
          >
            {/* <img
              src="/assets/layout/images/choose-language.svg"
              alt="choose language image"
              className="mx-auto fadeinleft animation-duration-1000"
              // className="pt-5"
              // className="md:ml-auto block md:h-full"
              style={{
                // clipPath: 'polygon(8% 0, 100% 0%, 100% 100%, 0 100%)',
                width: 'inherit',
                height: '25vh',
                marginTop: '30px !important',
                // padding: '3vh',import { useEffect } from 'react';
              }}
            /> */}
            {branding && (
              <div
                style={{
                  // clipPath: 'polygon(8% 0, 100% 0%, 100% 100%, 0 100%)',
                  width: 'inherit',
                  height: '25vh',
                  marginTop: '30px !important',
                  // padding: '3vh',import { useEffect } from 'react';
                }}
              >
                <ChooseLanguageIllustration
                  clothesColor={branding?.illustrations.clothesColor}
                  skinColor={branding?.illustrations.skinColor}
                  redPuzzleColor={branding?.illustrations.redPuzzleColor}
                />
              </div>
            )}

            {/* </div> */}
            <div>
              <h3
                style={{ color: '#333' }}
                className="my-5 fadeinup animation-duration-1000"
              >
                {t('ChooseLanguage')}
              </h3>
              <p className="text-center fadeinup animation-duration-1000">
                {t('SelectLanguage')}
              </p>
              {/* </div> */}
              <Language style={{ width: '100%' }} />
              {/* <Link className="p-button mt-4" to="/add-team-name">
            Next
          </Link> */}
            </div>
            <Button
              label={t('Next')}
              icon={
                <>
                  <div
                    className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                    style={{
                      backgroundColor: branding?.buttonPrimary.textColor,
                    }}
                  >
                    {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                  </div>
                  <ArrowRight
                    color={branding?.buttonPrimary.backgroundColor}
                    // variant="Bold"
                    className="icon-center"
                    // className="p-button-icon p-c p-button-icon-right"
                  />
                </>
              }
              className="p-button-rounded mt-4 py-3 zoominleft animation-duration-1000 uppercase"
              style={{
                backgroundColor: branding?.buttonPrimary.backgroundColor,
                color: branding?.buttonPrimary.textColor,
              }}
              // className="p-button-rounded mt-4 py-3 zoominleft animation-duration-1000"
              onClick={() => {
                clickSound()
                navigate('/add-team-name')
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ChooseLanguage
